import { ConditionalRenderer } from "components";
import styles from "./styles.module.scss";
import { AiIcon, ManualIcon } from "icons";
import moment from "moment";
import { useLanguageTranslator } from "hooks/use-language-translator";
import { UseApiCallV2 } from "hooks";
import { useParams } from "react-router-dom";
import { Spin } from "antd";
import { EmptyDataLabel } from "components/empty-data-label";

export const StatusHistoryTable = ({ case_id }) => {
  const { translator } = useLanguageTranslator();
  const { caseId } = useParams();
  const columnsLabels = translator("casesTable.tableColumnsLabel");

  const { data: statusHistory, isLoading } = UseApiCallV2({
    url: "/get_status_history",
    method: "POST",
    paramsData: {
      case_id,
    },
  });

  // get_email_reminders
  const data = statusHistory?.history;
  return (
    <Spin spinning={isLoading}>
      <div className={styles.tableContainer}>
        <table className={styles.myTable}>
          <thead>
            <tr>
              <th>Nr.</th>
              <th>Aktualisiert von</th>
              <th>Aktualisiert am</th>
              <th>Vorheriger Status</th>
              <th>Aktueller Status</th>
            </tr>
          </thead>
          <tbody>
            <ConditionalRenderer condition={data?.length > 0}>
              {data?.map((row, index) => (
                <tr key={row?.id?.toString()}>
                  <td>{index + 1}</td>
                  <td className={styles.updatedBy}>{row.changedBy}</td>
                  <td>
                    {row.changedAt
                      ? moment(row.changedAt, "YYYY-MM-DD HH:mm:ss").format(
                          "DD-MM-YYYY HH:mm:ss",
                        )
                      : ""}
                  </td>
                  <ConditionalRenderer condition={row.previousStatus}>
                    <td
                      className={`${styles.dropdown} ${styles?.[row.previousStatus]}`}
                    >
                      {row.previousStatus}
                    </td>
                  </ConditionalRenderer>
                  <ConditionalRenderer condition={row.newStatus}>
                    <td
                      className={`${styles.dropdown} ${styles?.[row.newStatus]}`}
                    >
                      {row.newStatus}
                    </td>
                  </ConditionalRenderer>
                </tr>
              ))}
            </ConditionalRenderer>
            <ConditionalRenderer condition={data?.length < 1}>
              <div className={styles.noData}>
                <EmptyDataLabel />
              </div>
            </ConditionalRenderer>
          </tbody>
        </table>
      </div>
    </Spin>
  );
};
